import { User } from "../../models/user";

export class UpdateUser {
  public static readonly type = "[Users] Update User";
  public constructor(public user: User) {}
}
